<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="bp-passive-monitoring-card">
    <div class="bp-card-header">
      <div class="bp-name">{{ businessProcess.businessProcessName }}</div>
      <div class="agent-state-summary">
        <v-tooltip color="surface">
          <template v-slot:activator="{ on }">
            <div
              v-for="agentState in agentStateSummary"
              :key="agentState.name"
              :style="{ backgroundColor: agentState.color }"
              class="agent-state-summary-box"
              v-on="on"
            >
              {{ agentState.value }}
            </div>
          </template>
        </v-tooltip>
      </div>
    </div>
    <div class="bp-health">
      Health: <span v-if="criticalKpi" :style="{ color: getHealthColor(criticalKpi.status) }">{{ currentHealth }}</span>
    </div>
    <div class="bp-health-kpis">
      <div v-for="kpi in criticalKpis" :key="kpi.id" class="bp-health-kpi">
        <div class="bp-health-kpi-value" :style="{ color: getKpiColor(kpi.status) }">
          {{ getFormattedValue(kpi.amount, kpi.type) }}<span class="bp-health-kpi-units">{{ kpi.units }}</span>
        </div>
        <div v-once class="bp-health-kpi-description">{{ $t(`kpis.${kpi.id}`) }}</div>
      </div>
    </div>
    <div v-show="!!supervisorInsight" class="insights">
      <v-icon small class="insight-icon">mdi-information</v-icon>
      <span>{{ supervisorInsight }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HEALTH_STATUS } from '@/constants/businessProcess/constants';
import EcsBusinessProcessHealthMixins from '@/mixins/ecs-business-process-health/EcsBusinessProcessHealthMixins';

export default {
  name: 'EcsBusinessProcessPassiveMonitoringCard',

  mixins: [EcsBusinessProcessHealthMixins],

  props: {
    businessProcessId: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('STATS', ['getBusinessProcessStatsById']),

    businessProcessStats() {
      return this.getBusinessProcessStatsById(this.businessProcessId);
    },

    agentStateSummary() {
      return [
        {
          name: this.$t('agentsStates.ready'),
          value: this.businessProcessStats.totalReadyAgents,
          color: 'var(--v-success-base)'
        },
        {
          name: this.$t('agentsStates.busy'),
          value: this.businessProcessStats.totalBusyAgents,
          color: 'var(--v-error-base)'
        },
        {
          name: this.$t('agentsStates.break'),
          value: this.businessProcessStats.totalBreakAgents,
          color: 'var(--v-warning-darken1)'
        }
      ];
    },

    currentHealth() {
      let result = '';

      if (!this.criticalKpi) {
        return result;
      }

      switch (this.criticalKpi.status) {
        case HEALTH_STATUS.Good:
          result = 'Good';
          break;
        case HEALTH_STATUS.Warning:
          result = 'Warning';
          break;
        case HEALTH_STATUS.Danger:
          result = 'Danger';
          break;
      }

      return result;
    },

    supervisorInsight() {
      return ''; // TODO: It's a placeholder until we will define the proper logic
    }
  }
};
</script>

<style scoped>
.bp-passive-monitoring-card {
  display: grid;
  grid-template-rows: 42px 24px auto 24px;
  border-radius: 8px;
  background-color: var(--v-surface-lighten1);
  height: 100%;
}

.bp-card-header {
  display: grid;
  grid-template-columns: auto 96px;
}

.bp-name {
  font-size: 28px;
  padding-left: 8px;
}

.agent-state-summary {
  display: grid;
  grid-template-columns: auto auto auto;
}

.agent-state-summary-box {
  width: 28px;
  height: 28px;
  border: 2px solid white;
  border-radius: 4px;
  align-self: center;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: white;
}

.bp-health {
  line-height: 24px;
  padding-left: 8px;
}

.bp-health-kpis {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: space-around;
  height: 100%;
}

.bp-health-kpi {
  display: grid;
  grid-template-rows: 72px 24px;
  height: 100%;
  align-content: center;
  padding: 0 8px;
}

.bp-health-kpi-value {
  justify-self: center;
  align-self: center;
  font-size: 72px;
}

.bp-health-kpi-description {
  justify-self: center;
  align-self: center;
  height: 14px;
  line-height: 14px;
  text-align: center;
}

.bp-health-kpi-units {
  font-size: 36px;
}

.insights {
  grid-row: 4;
  grid-column: 1 / span 2;
  line-height: 24px;
}

.insight-icon {
  font-size: 16px;
  color: var(--v-info-lighten1);
  vertical-align: middle;
  margin-right: 8px;
}

.insights > span {
  vertical-align: middle;
  font-size: 12px;
}
</style>
